module.exports = __webpack_public_path__ + "img/product-preview-47.6dff8cd.png";